export class LoginModel {
  constructor(userName, password) {
    this.email = userName;
    this.password = password;
  }
}